import { state } from "@react-rxjs/core"
import { defer, noop, of } from "rxjs"
import { map } from "rxjs/operators"

import { connectToTradingGateway } from "@/generated/TradingGateway"
import { runtimeConfig } from "@/services/runtimeConfig"

export const tradingGateway$ = state(
  // Delay creation until first subscription, so that merely importing this
  // module does not construct a gateway.
  defer(() =>
    of(
      connectToTradingGateway({
        url: runtimeConfig.hydraUrl,
        // Disable autoConnect and call connect() explicitly in initConnection()
        autoConnect: false,
        interceptor: noop,
        autoReconnect: true,
        reconnectInterval: 10000,
        useJson: !!import.meta.env.DEV,
      }),
    ),
  ),
)

export const tradingGatewayServices$ = state(
  tradingGateway$.pipe(map(({ services }) => services)),
)
